const PerfilAcessoIdEnum = {
  MASTER: 2
}

export default PerfilAcessoIdEnum



// WEBPACK FOOTER //
// ./client/enum/perfilAcessoEnum.js